module.exports = __webpack_public_path__ + "img/payment_icon_csobgtw.e5ca03ec.png";